import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { installGlobalErrorHooks } from './app/analytics/error/global-error-hooks';

// Installed before bootstrap so it also catches anything thrown during
// bootstrapping itself — Angular's own ErrorHandler isn't wired up yet at
// that point, and only ever sees in-zone errors once it is.
installGlobalErrorHooks();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch((err:any) => console.error(err));
